// src/firebase.js
// ✅ এখানে আপনার Firebase project এর config দিন
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBZd1cez0A46DaEKTEgR6O1EZJ6PUpnEtg",
  authDomain: "kinakata-6aba4.firebaseapp.com",
  databaseURL: "https://kinakata-6aba4-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "kinakata-6aba4",
  storageBucket: "kinakata-6aba4.firebasestorage.app",
  messagingSenderId: "170879492847",
  appId: "1:170879492847:web:4512a543d5e49a2206f11a",
  measurementId: "G-TSY9ZRSS5R"
};


const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
